const toPixels = (value) => `${value}px`;

export const HEADER_HEIGHT = 55;
export const HEADER_HEIGHT_PX = toPixels(HEADER_HEIGHT);
